var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question column",class:_vm.width},[_c('div',{staticClass:"question-content card"},[_c('div',{staticClass:"card-content",domProps:{"innerHTML":_vm._s(_vm.decodeHtml(_vm.question.question[_vm.lang]))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }